import { WalletKycAddresses } from '../../../types/wallet/WalletKycAddresses';
import { request } from '../../../utils/request';

export default function (authToken: string): Promise<WalletKycAddresses[]> {
  return request({
    url: '/sterling/kyc/addresses',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    onError: (error) => {
      throw error;
    },
  });
}
